/**
 * Is the page in a state where talking to the server makes sense?
 *
 * A hidden tab (timers throttled, nobody looking) or a browser that knows it is offline (a Mac
 * waking up, Wi-Fi coming back) cannot read anything: every request fails with « Failed to fetch »
 * / « Load failed ». The Realtime channels and the periodic reads wait for the page to wake up
 * instead of counting those failures as errors (constaté jusqu'au 28/10/2026 : ~25 « erreurs »
 * pour une seule mise en veille).
 */

export function isTabVisible(): boolean {
  return typeof document === 'undefined' || document.visibilityState !== 'hidden';
}

export function isOnline(): boolean {
  return typeof navigator === 'undefined' || navigator.onLine !== false;
}

/** Visible and online: a failure now is a real signal, not a sleeping page. */
export function isPageAwake(): boolean {
  return isTabVisible() && isOnline();
}
